// extracted by mini-css-extract-plugin
export var btnLogin = "HelpCenterHeader-module--btnLogin--e0f3a";
export var btnWrapper = "HelpCenterHeader-module--btnWrapper--10bb1";
export var header = "HelpCenterHeader-module--header--848fb";
export var heading = "HelpCenterHeader-module--heading--2d15b";
export var logo = "HelpCenterHeader-module--logo--6d909";
export var name = "HelpCenterHeader-module--name--1979e";
export var root = "HelpCenterHeader-module--root--3403d";